import blurred_img_1 from '@/assets/images/random-blurred-surprises/blurred_img_1.png'
import blurred_img_2 from '@/assets/images/random-blurred-surprises/blurred_img_2.png'
import blurred_img_3 from '@/assets/images/random-blurred-surprises/blurred_img_3.png'
import blurred_img_4 from '@/assets/images/random-blurred-surprises/blurred_img_4.png'
import blurred_img_5 from '@/assets/images/random-blurred-surprises/blurred_img_5.png'
import blurred_img_6 from '@/assets/images/random-blurred-surprises/blurred_img_6.png'
import blurred_img_7 from '@/assets/images/random-blurred-surprises/blurred_img_7.png'
import blurred_img_8 from '@/assets/images/random-blurred-surprises/blurred_img_8.png'
import blurred_img_9 from '@/assets/images/random-blurred-surprises/blurred_img_9.png'
import blurred_img_10 from '@/assets/images/random-blurred-surprises/blurred_img_10.png'
import {MediaTypeE} from '@/types'

export type Photos = {
    id?: number
    user_id?: number
    main?: boolean
    created_at?: string
    under_validation?: boolean
    type?: MediaTypeE
    url: string | null | undefined
    path_location?: string | null | undefined
    percent?: number
    chance?: boolean
    surprise?: boolean
}

export const blurredPhotos = [
    blurred_img_1,
    blurred_img_2,
    blurred_img_3,
    blurred_img_4,
    blurred_img_5,
    blurred_img_6,
    blurred_img_7,
    blurred_img_8,
    blurred_img_9,
    blurred_img_10
]

export const isValidBlurhash = (hashString: string) => {
    if (!hashString || typeof hashString !== 'string' || hashString.length < 6) {
        return false
    }

    const validChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz#$%*+,-.:;=?@[]^_{|}~'

    for (const char of hashString) {
        if (validChars.indexOf(char) === -1) {
            return false
        }
    }

    return true
}
